import { z } from 'zod'

/**
 * Search params schema for billing dashboard
 * This defines the structure of URL search parameters that persist filter state
 */
export const billingSearchSchema = z.object({
  // Date range filter
  dateRange: z.enum(['today', 'this-week', 'this-month', 'this-year', 'custom']).optional(),
  fromDate: z.string().optional(),
  toDate: z.string().optional(),
  
  // Report scope: workstation (default) or organization (ViewAllLocations only)
  scope: z.enum(['workstation', 'organization']).optional(),
  // Workstation filter
  oriCode: z.string().optional(),
  // Organization filter (used when scope=organization, ViewAllLocations only)
  tenantId: z.string().optional(),

  // Application type filter
  type: z.string().optional(),
  
  // Submission type filter
  submissionType: z.string().optional(),
  
  // Cost range filters - stored as strings in URL, transformed to numbers
  costFrom: z.string().optional().transform((val) => val && val !== '' ? Number(val) : undefined),
  costTo: z.string().optional().transform((val) => val && val !== '' ? Number(val) : undefined),
  
  // Pagination - stored as string in URL, transformed to number (defaults to 1)
  page: z.string().optional().transform((val) => val && val !== '' ? Number(val) : 1),
  
  // Active tab - stored in URL for persistence
  tab: z.enum(['billing', 'print']).optional(),
  
  // Export type (not persisted in URL, but included for completeness)
  exportType: z.enum(['pdf', 'csv']).optional(),
})

export type BillingSearchParams = z.infer<typeof billingSearchSchema>

